const variants = document.querySelectorAll('.single-variant-box');
const packagePrice = document.querySelector('.package-box-price');
const packageBox = document.querySelector('#package-box');
const tier1Price = parseFloat(variants[0].dataset.variantPrice.replace(/[^0-9.]/g, ''));

variants.forEach(variant => {
  variant.addEventListener('click', () => {
    variants.forEach(v => v.classList.remove('active'));
    variant.classList.add('active');

    const variantPriceText = variant.dataset.variantPrice;
    const variantPrice = parseFloat(variantPriceText.replace(/[^0-9.]/g, ''));
    const savings = tier1Price - variantPrice;
    const savingsEl = variant.querySelector('.savings-text');

    // Update price
    packagePrice.innerText = variantPriceText;

    // Clear previous savings text
    document.querySelectorAll('.savings-text').forEach(el => {
      el.innerText = '';
      el.style.display = 'none';
    });

    // Show savings if applicable
    if (savings > 0) {
      savingsEl.innerText = `SAVE $${savings.toFixed(2)} per unit vs. Tier 1!`;
      savingsEl.style.display = 'block';
    }

    // 🔄 Change background image dynamically
    const newImage = variant.dataset.variantImage;
    if (newImage) {
      packageBox.style.backgroundImage = `url(${newImage})`;
    }
  });
});
